<template>
    <Card :bordered="false" class="border-radius-0" :bodyStyle="{ padding: '24px 24px 0px 24px' }">
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Collapse v-model:activeKey="data.collapseRequestForm" v-if="isCanSelectRequestForm">
            <CollapsePanel :header="$t('model.licenseRequest.createRequestCollapse.title')" key="requestForm">
                <Row :gutter="8" justify="space-around">
                    <Col :md="4" class="btn-request-license">
                        <a>
                            <Card :bordered="true"
                                  :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px', borderRadius: '8px !important' }"
                                  class="request-btn  text-center h-80 blue-navy-color font-white"
                                  @click="() => onClickCreate({ routerPrefix: `${router.currentRoute.value.name}`})">
                                <CIcon file="request-license.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.licenseRequest.createRequestCollapse.button.requestLicense") }}</span>
                                </div>
                            </Card>
                        </a>
                    </Col>
                    <Col :md="4">
                        <a>
                            <Card :bordered="true" :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px' }"
                                  class="request-btn text-center h-80 solid-gray-color font-white"
                                  @click="() => onClickCreate({ routerPrefix: `transfer-${router.currentRoute.value.name}`})">
                                <CIcon file="transfer-license.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.licenseRequest.createRequestCollapse.button.transferLicense") }}</span>
                                </div>
                            </Card>
                        </a>
                    </Col>
                    <Col :md="4">
                        <a>
                            <Card :bordered="true" :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px' }"
                                  class="request-btn text-center h-80 orange-color font-white"
                                  @click="() => onClickCreate({ routerPrefix: `change-${router.currentRoute.value.name}`})">
                                <CIcon file="edit-license.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.licenseRequest.createRequestCollapse.button.changeLicense") }}</span>
                                </div>
                            </Card>
                        </a>
                    </Col>
                    <Col :md="4">
                        <a>
                            <Card :bordered="true" :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px' }"
                                  class="request-btn text-center h-80 white-green-color font-white"
                                  @click="() => onClickCreate({ routerPrefix: `renew-${router.currentRoute.value.name}`})">
                                <CIcon file="renew-license.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.licenseRequest.createRequestCollapse.button.renewLicense") }}</span>
                                </div>
                            </Card>
                        </a>
                    </Col>
                    <Col :md="4">
                        <a>
                            <Card :bordered="true" :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px' }"
                                  class="request-btn text-center h-80 brown-color font-white"
                                  @click="() => onClickCreate({ routerPrefix: `replacement-${router.currentRoute.value.name}`})">
                                <CIcon file="replace-license.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.licenseRequest.createRequestCollapse.button.requestReplacement") }}</span>
                                </div>
                            </Card>
                        </a>
                    </Col>
                    <Col :md="4">
                        <a>
                            <Card :bordered="true" :bodyStyle="{ paddingLeft: '0px', paddingRight: '0px' }"
                                  class="request-btn  text-center h-80 solid-red-color font-white"
                                  @click="() => onClickCreate({ routerPrefix: `cancel-${router.currentRoute.value.name}`})">
                                <CIcon file="cancel-license.svg" style="font-size: 50px"></CIcon>
                                <div>
                                    <span>{{ $t("model.licenseRequest.createRequestCollapse.button.cancelLicense") }}</span>
                                </div>
                            </Card>
                        </a>
                    </Col>
                </Row>
            </CollapsePanel>
        </Collapse>
    </Card>

    <Card :bordered="false" class="border-radius-0">
        <CTable
                :isLoading="isLoading"
                v-model:columns="state.columns"
                v-model:page="state.page"
                :options="state.tableOptions"
                :manages="state.manages"
                :manageExtras="state.manageExtras"
                :rowActions="state.rowActions"
                @search="search => onSearch({ props, ...search })"
        ></CTable>
    </Card>
</template>

<script>
    import { Card, Row, Col, Collapse } from "ant-design-vue";
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { state as stateApp } from "../../../../app.logic";
    import { initState, isLoading, onSearch, state } from "./request.logic";
    import { onClickCreate } from "../../../../utils/form";
    import router from "../../../../router";
    import { has } from "../../../../utils/menu-context";

    export default defineComponent({
        components: {
            Card,
            Col,
            Row,
            Collapse,
            CollapsePanel: Collapse.Panel,
            CIcon: defineAsyncComponent(() => import("../../../../components/icon/CIcon")),
            CTable: defineAsyncComponent(() => import("../../../../components/table/CTable"))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "license-requests" }
        },
        setup(props) {
            const isCanSelectRequestForm = has({ menuContext: props.menuContext, key: "forSendRequest" });
            const data = reactive({ collapseRequestForm: "requestForm" });
            initState({ props, data });
            return {
                props,
                isLoading,
                state,
                onSearch,
                onClickCreate,
                Row,
                Col,
                Card,
                router,
                data,
                isCanSelectRequestForm
            };
        }
    });
</script>


<style scoped>
    .request-btn {
        border-radius: 8px !important;
    }

    .font-white {
        color: white !important;
    }

    .blue-navy-color {
        background-color: #1164B4 !important;
    }

    .solid-gray-color {
        background-color: #333F50 !important;
    }

    .orange-color {
        background-color: #FFC000 !important;
    }

    .white-green-color {
        background-color: #A9D18E !important;
    }

    .brown-color {
        background-color: #C55A11 !important;
    }

    .solid-red-color {
        background-color: #C00000 !important;
    }
</style>